// shared/store/slices/generalSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { generalMock } from '@/shared/store/mocks';

export interface GeneralState {
    loadingMap: Record<string, boolean>;
    errorMap: Record<string, string | null>;
    useMockDelay: boolean;
    preloaderMinDurationMs: number;
}

const initialState: GeneralState = {
    loadingMap: {},
    errorMap: {},
    useMockDelay: false,
    preloaderMinDurationMs: generalMock.preloaderMinDurationMs,
};

const generalSlice = createSlice({
    name: 'general',
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<{ key: string; value: boolean }>) => {
            state.loadingMap[action.payload.key] = action.payload.value;
        },
        setError: (state, action: PayloadAction<{ key: string; value: string | null }>) => {
            state.errorMap[action.payload.key] = action.payload.value;
        },
        clearError: (state, action: PayloadAction<string>) => {
            delete state.errorMap[action.payload];
        },
        clearAll: state => {
            state.loadingMap = {};
            state.errorMap = {};
        },
        setUseMockDelay: (state, action: PayloadAction<boolean>) => {
            state.useMockDelay = action.payload;
        },
        setPreloaderMinDurationMs: (state, action: PayloadAction<number>) => {
            state.preloaderMinDurationMs = action.payload;
        },
    },
});

export const { setLoading, setError, clearError, clearAll, setUseMockDelay, setPreloaderMinDurationMs } =
    generalSlice.actions;
export default generalSlice.reducer;
